/* eslint-disable */
import { IState } from "@/interfaces/IState";
import { ILayout } from "@/interfaces/layout/ILayout";

export const ui = {
    state: {
        layout: "main-layout",
        drawer: false,
        cardMode: true,
        innerWindow: {
            width: 0,
            height: 0
        },
        isLoading: false,
    },
    mutations: {
        SET_LAYOUT(state: IState, newLayout: any) {
            state.layout = newLayout;
        },
        UPDATE_DRAWER(state: IState, payload: any) {
            state.drawer = payload;
        },
        TOGGLE_LIST_MODE(state: IState) {
            state.cardMode = !state.cardMode;
        },
        SET_INNER_WINDOW(state: IState, payload: any) {
            state.innerWindow = payload;
        },
        SET_LOADING(state: IState, payload: any) {
            state.isLoading = payload;
        }
    },
    actions: {
        setLayout(context: any, payload: ILayout) {
            context.commit("SET_LAYOUT", payload);
        },
        toggleDrawer(context: any, payload: any) {
            context.commit("UPDATE_DRAWER", payload);
        },
        toggleListMode(context: any) {
            context.commit("TOGGLE_LIST_MODE");
        },
        setInnerWindow(context: any, payload: any) {
            context.commit("SET_INNER_WINDOW", payload);
        },
        setIsLoading(context: any, payload: any) {
            context.commit("SET_LOADING", payload);
        }
    },
    getters: {
        getLayout(state: IState) {
            return state.layout;
        },
        getDrawer(state: IState) {
            return state.drawer;
        },
        getCardMode(state: IState) {
            return state.cardMode;
        },
        getInnerWindow(state: IState) {
            return state.innerWindow;
        },
        getLoading(state: IState) {
            return state.isLoading;
        }
    }
};
